// 导入css动画效果
import { CSSTransition } from "react-transition-group";

const CSSTrans = function(show, classNames, el) {
  return (
    <CSSTransition
      in={show}
      timeout={10000}
      classNames={classNames}
      unmountOnExit
    >
      {el}
    </CSSTransition>
  );
}
export default CSSTrans
